import type {
  ToolResultBlock,
  TranscriptContentBlock,
  TranscriptMessage,
} from '~/entities/document-agent'

function blocksOf(message: TranscriptMessage): TranscriptContentBlock[] {
  return Array.isArray(message.content) ? message.content : []
}

export function isToolResultBlock(block: TranscriptContentBlock): block is ToolResultBlock {
  return block.type === 'tool_result'
}

/** `tool_use` block id → tool name, so a tool result can say what it answers. */
export function buildToolNameIndex(messages: TranscriptMessage[]): Record<string, string> {
  const index: Record<string, string> = {}
  for (const message of messages) {
    for (const block of blocksOf(message)) {
      if (block.type === 'tool_use' && block.id) index[block.id] = block.name
    }
  }
  return index
}
